import React, { useState } from "react";
import "./LandingPage.css";

//import SankeyPanelwater from "./SankeyPanelwater";
//import SankeyPanelwater from "./SP";
import SankeyPanelwater from "./SankeyPanelwater3";
import heroBg from "../assets/hero.png";
import actionOne from "../assets/hero.png";
import actionTwo from "../assets/bg_1.jpg";
import donateWidget from "../assets/twt-diagram.png";
import fieldBg from "../assets/hero.png";

import IWMI_Logo from "../assets/IWMI_Logo.png";
import CGIAR_transparent from "../assets/cgiar_transparent.png";
import partnerLogo1 from "../assets/NCAR.png";
import partnerLogo2 from "../assets/usgs.png";
import partnerLogo3 from "../assets/helmsley.png";
import partnerLogo4 from "../assets/digital_earth_africa.png";
import MethodologyImg from "../assets/methodology.png";

export default function LandingPage() {
  const [showTracker, setShowTracker] = useState(false);
  const [showMethodology, setShowMethodology] = useState(false);
  const [showEventsPanel, setShowEventsPanel] = useState(false);
  const [showEventsPage, setShowEventsPage] = useState(false);
  const [showEventAnnouncement, setShowEventAnnouncement] = useState(true);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) section.scrollIntoView({ behavior: "smooth" });
  };

  const openTracker = () => {
    setShowMethodology(false);
    setShowTracker(true);
  };

  const openMethodology = () => {
    setShowTracker(false);
    setShowMethodology(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const iwmiEvents = [
    {
      id: "cairo-water-week-2026",
      title: "IWMI at Cairo Water Week 2026",
      start: "2026-10-25T00:00:00",
      end: "2026-10-25T23:59:59",
      dateLabel: "25 October 2026",
      location: "Cairo, Egypt",
      type: "CONFERENCE",
      description: "IWMI participates in Cairo Water Week 2026, connecting water-sector stakeholders and sharing knowledge on water management.",
      url: "https://www.iwmi.org/events/",
    },
    {
      id: "digital-water-symposium-2026",
      title: "Shaping Africa’s Digital Water Future: A Pan-African Symposium",
      start: "2026-10-28T00:00:00",
      end: "2026-10-29T23:59:59",
      dateLabel: "28–29 October 2026",
      timeLabel: "8:30 am–5:00 pm (Africa/Accra)",
      location: "Lancaster Accra, Liberation Road, Accra, Ghana",
      type: "SYMPOSIUM",
      description: "The symposium brings together policymakers, researchers, innovators, private-sector actors, river basin organizations and development partners. It showcases real-world digital water technologies, including satellite data, cloud computing and tools that support timely, informed decisions from irrigation schemes to river basins.",
      registrationClosed: true,
      url: "https://www.iwmi.org/events/shaping-africas-digital-water-future-a-pan-african-symposium/",
    },
    {
      id: "cop31-2026",
      title: "COP31 UNFCCC",
      start: "2026-11-09T00:00:00",
      end: "2026-11-09T23:59:59",
      dateLabel: "9 November 2026",
      location: "Istanbul, Türkiye",
      type: "CONFERENCE",
      description: "IWMI’s listed upcoming engagement at COP31 UNFCCC.",
      url: "https://www.iwmi.org/events/",
    },
  ];
  const now = new Date();
  const eventStart = (event) => new Date(event.start);
  const eventEnd = (event) => new Date(event.end);
  const currentEvents = iwmiEvents.filter((event) => eventStart(event) <= now && eventEnd(event) >= now);
  const upcomingEvents = iwmiEvents.filter((event) => eventStart(event) > now).sort((a, b) => eventStart(a) - eventStart(b));
  const pastEvents = iwmiEvents.filter((event) => eventEnd(event) < now).sort((a, b) => eventStart(b) - eventStart(a));
  const featuredEvent = upcomingEvents[0] || currentEvents[0] || null;
  const formatEventDate = (event) => event.dateLabel;

  if (showEventsPage) {
    return (
      <main className="iwmi-events-page" style={{ backgroundImage: `linear-gradient(rgba(4, 24, 38, .72), rgba(4, 24, 38, .82)), url(${heroBg})` }}>
        <header className="iwmi-events-site-header">
          <div className="iwmi-events-logo-row">
            <img className="iwmi-events-logo" src={IWMI_Logo} alt="IWMI logo" />
            <span className="iwmi-events-logo-divider" />
            <img className="iwmi-events-cgiar-logo" src={CGIAR_transparent} alt="CGIAR logo" />
            <span className="iwmi-events-brand">TRANSBOUNDARY WATER TRACKER</span>
          </div>
          <nav className="iwmi-events-nav" aria-label="Main navigation">
            <button onClick={() => { setShowEventsPage(false); setShowEventAnnouncement(true); }}>Home</button>
            <button onClick={() => { setShowEventsPage(false); setShowEventAnnouncement(true); openMethodology(); }}>Methodology</button>
            <button onClick={() => { setShowEventsPage(false); setShowEventAnnouncement(true); openTracker(); }}>Explore Tracker</button>
            <button className="active" aria-current="page">IWMI Events</button>
          </nav>
        </header>
        <section className="iwmi-events-heading">
          <p className="iwmi-events-kicker">IWMI NEWS &amp; EVENTS</p>
          <h1>What's happening across the IWMI water community.</h1>
          <p>Symposia, conferences and knowledge-sharing events connected to water, data and digital innovation.</p>
        </section>

        {featuredEvent ? (
          <section className="iwmi-featured-event" aria-label="Featured event">
            <div className="iwmi-featured-date">
              <span className="iwmi-date-rule" />
              <span className="iwmi-save-date">{currentEvents.length ? "HAPPENING NOW" : "NEXT UP"}</span>
              <strong>{formatEventDate(featuredEvent)}</strong>
              <span>{featuredEvent.location}</span>
            </div>
            <div className="iwmi-featured-details">
              <div className="iwmi-event-labels"><span>{featuredEvent.type}</span><b>{currentEvents.length ? "CURRENT EVENT" : "FEATURED EVENT"}</b></div>
              <h2>{featuredEvent.title}</h2>
              <p className="iwmi-event-date-line">▦ &nbsp;{formatEventDate(featuredEvent)}{featuredEvent.timeLabel ? ` · ${featuredEvent.timeLabel}` : ""}</p>
              <p className="iwmi-event-location">⌖ &nbsp;{featuredEvent.location}</p>
              <p>{featuredEvent.description}</p>
              <a className="iwmi-register-button iwmi-register-link" href={featuredEvent.url} target="_blank" rel="noreferrer">
                {featuredEvent.registrationClosed ? "View event details — Registration closed ↗" : "View official event details ↗"}
              </a>
            </div>
          </section>
        ) : (
          <section className="iwmi-current-events"><h2>No upcoming events listed</h2><p className="iwmi-current-empty">Please visit the official IWMI events page for the latest announcements.</p><a href="https://www.iwmi.org/events/" target="_blank" rel="noreferrer">Browse official IWMI events ↗</a></section>
        )}

        <section className="iwmi-event-list-section">
          <h2>Upcoming <span>· {upcomingEvents.length}</span></h2>
          {upcomingEvents.length ? (
            <div className="iwmi-event-timeline">
              {upcomingEvents.map((event) => (
                <article className="iwmi-timeline-item" key={event.id}>
                  <div className="iwmi-timeline-date">{formatEventDate(event)}</div>
                  <div className="iwmi-timeline-content">
                    <div className="iwmi-event-labels"><span>{event.type}</span><small>⌖ &nbsp;{event.location}</small></div>
                    <h3>{event.title}</h3><p>{event.description}</p>
                    <a href={event.url} target="_blank" rel="noreferrer">{event.registrationClosed ? "Official details · Registration closed ↗" : "Official event details ↗"}</a>
                  </div>
                </article>
              ))}
            </div>
          ) : <p className="iwmi-current-empty">There are no future events in this list. Check the official IWMI calendar for updates.</p>}
        </section>

        <section className="iwmi-current-events">
          <h2>Current &amp; ongoing <span>· {currentEvents.length}</span></h2>
          {currentEvents.length ? currentEvents.map((event) => (
            <article className="iwmi-current-event-card" key={event.id}>
              <span className="iwmi-live-indicator">LIVE NOW</span><h3>{event.title}</h3>
              <p>{formatEventDate(event)} · {event.location}</p><p>{event.description}</p>
              <a href={event.url} target="_blank" rel="noreferrer">View official details ↗</a>
            </article>
          )) : <p className="iwmi-current-empty">No event in this list is scheduled for today. Upcoming events move here automatically during their event dates.</p>}
        </section>

        <section className="iwmi-event-list-section iwmi-past-events">
          <h2>Past events <span>· {pastEvents.length}</span></h2>
          {pastEvents.length ? <div className="iwmi-event-timeline">
            {pastEvents.map((event) => <article className="iwmi-timeline-item" key={event.id}>
              <div className="iwmi-timeline-date">{formatEventDate(event)}</div>
              <div className="iwmi-timeline-content"><div className="iwmi-event-labels"><span>PAST EVENT</span></div><h3>{event.title}</h3><p>{event.description}</p><a href={event.url} target="_blank" rel="noreferrer">View event information ↗</a></div>
            </article>)}
          </div> : <p className="iwmi-current-empty">Past events will appear here automatically after their dates have passed.</p>}
        </section>
        <p className="iwmi-events-source-note">Event information is based on the official IWMI events listings. <a href="https://www.iwmi.org/events/" target="_blank" rel="noreferrer">Visit IWMI Events ↗</a></p>
      </main>
    );
  }

  if (showTracker) {
    return <SankeyPanelwater onBack={() => setShowTracker(false)} />;
  }

  if (showMethodology) {
    return (
      <main className="hr-page methodology-page twt-methodology-innovative">
        <style>{`
          .twt-methodology-innovative { --twt-ink:#12342f; --twt-green:#176b52; --twt-lime:#d8ed9a; --twt-mist:#eef5ef; --twt-paper:#f8faf7; --twt-line:rgba(18,52,47,.14); color:var(--twt-ink); }
          .twt-methodology-innovative * { box-sizing:border-box; }
          .twt-methodology-innovative .twt-platform-hero { position:relative; isolation:isolate; overflow:hidden; min-height:620px; padding:28px clamp(22px,5vw,76px) 58px; background:#092f2c; color:#fff; }
          .twt-methodology-innovative .twt-platform-hero:before { content:""; position:absolute; z-index:-2; inset:0; background:linear-gradient(105deg,rgba(3,28,27,.96) 0%,rgba(5,49,44,.88) 52%,rgba(5,49,44,.45) 100%),url(${heroBg}) center/cover; }
          .twt-methodology-innovative .twt-platform-hero:after { content:""; position:absolute; z-index:-1; width:520px;height:520px;right:-110px;top:90px;border:1px solid rgba(216,237,154,.22);border-radius:50%;box-shadow:0 0 0 48px rgba(216,237,154,.035),0 0 0 100px rgba(216,237,154,.025); }
          .twt-methodology-innovative .twt-method-topbar { display:flex;align-items:center;justify-content:space-between;gap:24px;max-width:1320px;margin:0 auto 70px;position:relative;z-index:2; }
          .twt-methodology-innovative .twt-method-logo { display:flex;align-items:center;gap:16px;min-width:0; }
          .twt-methodology-innovative .twt-method-logo img:first-child { width:112px;max-height:54px;object-fit:contain; }
          .twt-methodology-innovative .twt-method-logo img:last-child { width:88px;max-height:50px;object-fit:contain; }
          .twt-methodology-innovative .twt-method-logo span { height:36px;width:1px;background:rgba(255,255,255,.4); }
          .twt-methodology-innovative .twt-method-nav { display:flex;gap:10px;flex-wrap:wrap; }
          .twt-methodology-innovative .twt-method-nav button { border:1px solid rgba(255,255,255,.4);border-radius:999px;background:rgba(255,255,255,.06);color:#fff;padding:11px 18px;font:inherit;cursor:pointer;transition:background .2s,transform .2s; }
          .twt-methodology-innovative .twt-method-nav button:hover { background:rgba(255,255,255,.16);transform:translateY(-1px); }
          .twt-methodology-innovative .twt-method-nav .twt-method-primary { background:var(--twt-lime);border-color:var(--twt-lime);color:#15382f;font-weight:700; }
          .twt-methodology-innovative .twt-hero-grid { display:grid;grid-template-columns:minmax(0,1.1fr) minmax(300px,.9fr);align-items:center;gap:clamp(30px,6vw,90px);max-width:1320px;margin:auto;position:relative;z-index:1; }
          .twt-methodology-innovative .twt-kicker { display:flex;align-items:center;gap:10px;text-transform:uppercase;letter-spacing:.16em;font-size:14px;font-weight:800;color:var(--twt-lime);margin:0 0 22px; }
          .twt-methodology-innovative .twt-kicker:before { content:"";display:block;width:28px;height:2px;background:var(--twt-lime); }
          .twt-methodology-innovative .twt-hero-copy h1 { max-width:720px;margin:0 0 22px;color:#fff;font-size:clamp(42px,5.4vw,76px);line-height:1.02;letter-spacing:-.045em;font-weight:750; }
          .twt-methodology-innovative .twt-hero-copy h1 em { color:var(--twt-lime);font-style:normal; }
          .twt-methodology-innovative .twt-hero-copy p { max-width:690px;color:rgba(255,255,255,.82);font-size:18px;line-height:1.8;margin:0 0 16px; }
          .twt-methodology-innovative .twt-hero-actions { display:flex;gap:12px;flex-wrap:wrap;margin-top:26px; }
          .twt-methodology-innovative .twt-hero-actions button { border:0;border-radius:999px;padding:13px 20px;background:var(--twt-lime);color:#173a31;font-weight:800;cursor:pointer; }
          .twt-methodology-innovative .twt-hero-actions .twt-secondary { border:1px solid rgba(255,255,255,.36);background:transparent;color:#fff; }
          .twt-methodology-innovative .twt-visual-card { padding:14px;border:1px solid rgba(255,255,255,.22);border-radius:24px;background:rgba(255,255,255,.09);box-shadow:0 28px 80px rgba(0,0,0,.2);backdrop-filter:blur(12px); }
          .twt-methodology-innovative .twt-visual-card img { display:block;width:100%;height:290px;object-fit:contain;background:#f7faf7;border-radius:15px;padding:12px; }
          .twt-methodology-innovative .twt-visual-caption { display:flex;align-items:center;justify-content:space-between;gap:14px;padding:18px 7px 7px; }
          .twt-methodology-innovative .twt-visual-caption strong { color:#fff;font-size:16px; }
          .twt-methodology-innovative .twt-visual-caption span { color:var(--twt-lime);font-size:14px; }
          .twt-methodology-innovative .twt-metric-strip { display:grid;grid-template-columns:repeat(3,1fr);max-width:1120px;margin:-1px auto 0;position:relative;z-index:3;background:#fff;border:1px solid var(--twt-line);border-radius:18px;box-shadow:0 18px 45px rgba(17,57,47,.1);overflow:hidden; }
          .twt-methodology-innovative .twt-metric { padding:25px 30px;display:flex;align-items:center;gap:16px;border-right:1px solid var(--twt-line); }
          .twt-methodology-innovative .twt-metric:last-child { border-right:0; }
          .twt-methodology-innovative .twt-metric b { display:block;font-size:clamp(23px,3vw,34px);line-height:1;color:var(--twt-green);letter-spacing:-.04em; }
          .twt-methodology-innovative .twt-metric span { display:block;margin-top:6px;font-size:14px;line-height:1.5;color:#526b63; }
          .twt-methodology-innovative .twt-section { padding:82px clamp(22px,5vw,76px); }
          .twt-methodology-innovative .twt-section-inner { max-width:1180px;margin:0 auto; }
          .twt-methodology-innovative .twt-section-heading { max-width:780px;margin:0 0 38px; }
          .twt-methodology-innovative .twt-section-heading .twt-kicker { color:var(--twt-green); }
          .twt-methodology-innovative .twt-section-heading .twt-kicker:before { background:var(--twt-green); }
          .twt-methodology-innovative .twt-section-heading h2 { margin:0 0 14px;font-size:clamp(30px,3.5vw,46px);line-height:1.12;letter-spacing:-.035em;color:var(--twt-ink); }
          .twt-methodology-innovative .twt-section-heading p { margin:0;color:#526b63;line-height:1.8;font-size:18px; }
          .twt-methodology-innovative .twt-data-section { background:#dcebd5; }
          .twt-methodology-innovative .twt-data-layout { display:grid;grid-template-columns:1fr .9fr;gap:28px;align-items:stretch; }
          .twt-methodology-innovative .twt-data-copy { background:rgba(255,255,255,.72);border:1px solid rgba(18,52,47,.12);border-radius:22px;padding:clamp(24px,3.4vw,42px); }
          .twt-methodology-innovative .twt-data-copy h3 { margin:0 0 16px;font-size:28px;color:var(--twt-ink); }
          .twt-methodology-innovative .twt-data-copy p { color:#405d53;line-height:1.8;font-size:18px;margin:0 0 17px; }
          .twt-methodology-innovative .twt-data-image { border-radius:22px;background:#fff;overflow:hidden;display:flex;align-items:center;justify-content:center;padding:22px;min-height:300px; }
          .twt-methodology-innovative .twt-data-image img { width:100%;height:100%;max-height:340px;object-fit:contain; }
          .twt-methodology-innovative .twt-process { display:grid;grid-template-columns:repeat(4,1fr);gap:12px;margin-top:28px; }
          .twt-methodology-innovative .twt-process-step { position:relative;background:#fff;border:1px solid rgba(18,52,47,.12);border-radius:16px;padding:24px 22px;min-height:170px; }
          .twt-methodology-innovative .twt-process-step b { display:flex;align-items:center;justify-content:center;width:34px;height:34px;border-radius:11px;background:var(--twt-green);color:white;font-size:12px;margin-bottom:16px; }
          .twt-methodology-innovative .twt-process-step h4 { margin:0 0 7px;font-size:17px;color:var(--twt-ink); }
          .twt-methodology-innovative .twt-process-step p { margin:0;color:#62766e;font-size:15px;line-height:1.65; }
          .twt-methodology-innovative .twt-cream-section { background:var(--twt-paper); }
          .twt-methodology-innovative .twt-method-cards { display:grid;grid-template-columns:repeat(12,minmax(0,1fr));gap:18px; }
          .twt-methodology-innovative .twt-method-card { grid-column:span 6;background:#fff;border:1px solid var(--twt-line);border-radius:20px;padding:clamp(23px,3vw,34px);box-shadow:0 9px 26px rgba(20,61,49,.035); }
          .twt-methodology-innovative .twt-method-card.wide { grid-column:span 12;display:grid;grid-template-columns:70px minmax(0,1fr);gap:22px; }
          .twt-methodology-innovative .twt-card-number { display:flex;align-items:center;justify-content:center;width:54px;height:54px;border-radius:17px;background:#e3f0dd;color:var(--twt-green);font-weight:850;font-size:17px; }
          .twt-methodology-innovative .twt-card-body h3 { margin:0 0 13px;color:var(--twt-ink);font-size:25px;line-height:1.3; }
          .twt-methodology-innovative .twt-card-body p { margin:0 0 13px;color:#526b63;line-height:1.85;font-size:16px; }
          .twt-methodology-innovative .twt-card-body p:last-child { margin-bottom:0; }
          .twt-methodology-innovative .twt-flow-rule { display:grid;grid-template-columns:1fr 1fr;gap:12px;margin:22px 0 6px; }
          .twt-methodology-innovative .twt-flow-rule div { padding:15px;border-radius:13px;background:#f0f6ef;border:1px solid #dbe9dc; }
          .twt-methodology-innovative .twt-flow-rule strong { display:block;color:var(--twt-green);font-size:15px;margin-bottom:7px; }
          .twt-methodology-innovative .twt-flow-rule span { display:block;color:#526b63;font-size:15px;line-height:1.65; }
          .twt-methodology-innovative .twt-caveat { background:#fff8e8;border-color:#f0dfb6; }
          .twt-methodology-innovative .twt-caveat .twt-card-number { background:#f7e8bd;color:#795b18; }
          .twt-methodology-innovative .twt-publications { background:#e3efdf; }
          .twt-methodology-innovative .twt-publications .section-head { max-width:1180px;margin:0 auto 28px; }
          .twt-methodology-innovative .twt-publications .publication-list { max-width:1180px;margin:0 auto; }
          .twt-methodology-innovative .twt-end-note { max-width:1180px;margin:24px auto 0;color:#597067;font-size:16px;line-height:1.75; }
          /* Accessibility/readability pass: increase supporting text throughout the methodology page. */
          .twt-methodology-innovative { font-size:18px; }
          .twt-methodology-innovative .twt-kicker { font-size:16px; }
          .twt-methodology-innovative .twt-hero-copy p { font-size:clamp(18px,1.35vw,20px);line-height:1.8; }
          .twt-methodology-innovative .twt-method-nav button,
          .twt-methodology-innovative .twt-hero-actions button { font-size:16px; }
          .twt-methodology-innovative .twt-visual-caption strong { font-size:17px; }
          .twt-methodology-innovative .twt-visual-caption span { font-size:15px; }
          .twt-methodology-innovative .twt-metric span { font-size:15px;line-height:1.55; }
          .twt-methodology-innovative .twt-section-heading p { font-size:18px;line-height:1.8; }
          .twt-methodology-innovative .twt-data-copy p { font-size:18px;line-height:1.8; }
          .twt-methodology-innovative .twt-process-step b { font-size:16px; }
          .twt-methodology-innovative .twt-process-step h4 { font-size:18px;line-height:1.35; }
          .twt-methodology-innovative .twt-process-step p { font-size:16px;line-height:1.7; }
          .twt-methodology-innovative .twt-card-body p { font-size:17px;line-height:1.8; }
          .twt-methodology-innovative .twt-flow-rule strong { font-size:16px; }
          .twt-methodology-innovative .twt-flow-rule span { font-size:15px;line-height:1.7; }
          .twt-methodology-innovative .twt-end-note { font-size:16px; }
          .twt-methodology-innovative .twt-publications .pub-content h4 { font-size:18px;line-height:1.45; }
          .twt-methodology-innovative .twt-publications .pub-content p { font-size:16px;line-height:1.6; }
          .twt-methodology-innovative .twt-publications .pub-number { font-size:16px; }
          .twt-methodology-innovative .twt-data-copy, .twt-methodology-innovative .twt-data-image, .twt-methodology-innovative .twt-method-card { transition:transform .22s ease, box-shadow .22s ease; }
          .twt-methodology-innovative .twt-data-copy:hover, .twt-methodology-innovative .twt-method-card:hover { transform:translateY(-3px); box-shadow:0 16px 36px rgba(20,61,49,.09); }
          .twt-methodology-innovative .twt-data-image { box-shadow:0 10px 28px rgba(20,61,49,.06); }
          .twt-methodology-innovative .twt-section-heading { margin-bottom:42px; }
          .twt-methodology-innovative .twt-data-copy p, .twt-methodology-innovative .twt-card-body p { max-width:78ch; }
          .twt-methodology-innovative .twt-end-note { font-size:16px; line-height:1.75; }
          @media(max-width:560px) {
            .twt-methodology-innovative .twt-hero-copy p { font-size:18px; }
            .twt-methodology-innovative .twt-section-heading p,
            .twt-methodology-innovative .twt-data-copy p,
            .twt-methodology-innovative .twt-card-body p { font-size:17px; }
            .twt-methodology-innovative .twt-process-step h4 { font-size:16px; }
            .twt-methodology-innovative .twt-process-step p { font-size:15px; }
          }
          @media(max-width:850px) { .twt-methodology-innovative .twt-hero-grid,.twt-methodology-innovative .twt-data-layout { grid-template-columns:1fr; } .twt-methodology-innovative .twt-method-topbar { margin-bottom:45px;align-items:flex-start;flex-direction:column; } .twt-methodology-innovative .twt-visual-card img { height:240px; } .twt-methodology-innovative .twt-process { grid-template-columns:repeat(2,1fr); } .twt-methodology-innovative .twt-method-card.wide { grid-template-columns:1fr; } }
          @media(max-width:560px) { .twt-methodology-innovative .twt-platform-hero { padding:22px 18px 42px; } .twt-methodology-innovative .twt-method-logo img:first-child { width:90px; } .twt-methodology-innovative .twt-method-logo img:last-child { width:72px; } .twt-methodology-innovative .twt-metric-strip { margin:0 14px;grid-template-columns:1fr; } .twt-methodology-innovative .twt-metric { border-right:0;border-bottom:1px solid var(--twt-line);padding:17px 22px; } .twt-methodology-innovative .twt-metric:last-child { border-bottom:0; } .twt-methodology-innovative .twt-section { padding:58px 18px; } .twt-methodology-innovative .twt-process { grid-template-columns:1fr 1fr; } .twt-methodology-innovative .twt-method-card { grid-column:span 12; } .twt-methodology-innovative .twt-flow-rule { grid-template-columns:1fr; } }

          /* Refined IWMI palette: forest green + teal + sky blue + restrained amber */
          .twt-methodology-innovative {
            --twt-ink:#12343b;
            --twt-green:#176b52;
            --twt-lime:#d9ed9a;
            --twt-mist:#edf6f2;
            --twt-paper:#f7faf8;
            --twt-line:rgba(18,52,59,.15);
          }
          .twt-methodology-innovative .twt-platform-hero:before {
            background:linear-gradient(112deg,rgba(7,39,43,.98) 0%,rgba(13,77,68,.91) 55%,rgba(13,93,103,.68) 100%),url(${heroBg}) center/cover;
          }
          .twt-methodology-innovative .twt-platform-hero:after {
            border-color:rgba(217,237,154,.28);
            box-shadow:0 0 0 48px rgba(65,190,174,.07),0 0 0 100px rgba(217,237,154,.035);
          }
          .twt-methodology-innovative .twt-kicker { color:#087c70; }
          .twt-methodology-innovative .twt-kicker:before { background:#1b9a88; }
          .twt-methodology-innovative .twt-section-heading .twt-kicker { color:#087c70; }
          .twt-methodology-innovative .twt-section-heading .twt-kicker:before { background:#1b9a88; }
          .twt-methodology-innovative .twt-data-section {
            background:linear-gradient(135deg,#e0efdc 0%,#e7f4ef 58%,#dceff0 100%);
            position:relative;
            overflow:hidden;
          }
          .twt-methodology-innovative .twt-data-section:before {
            content:"";position:absolute;right:-120px;top:-150px;width:390px;height:390px;border:1px solid rgba(23,107,82,.13);border-radius:50%;
            box-shadow:0 0 0 36px rgba(23,107,82,.035),0 0 0 74px rgba(8,124,112,.025);pointer-events:none;
          }
          .twt-methodology-innovative .twt-data-section .twt-section-inner { position:relative;z-index:1; }
          .twt-methodology-innovative .twt-data-copy {
            background:rgba(255,255,255,.88);border:1px solid rgba(23,107,82,.17);
            box-shadow:0 16px 40px rgba(22,74,58,.075);border-top:4px solid #25866b;
          }
          .twt-methodology-innovative .twt-data-copy h3 { color:#145743; }
          .twt-methodology-innovative .twt-data-copy p { color:#3f5d56; }
          .twt-methodology-innovative .twt-data-image {
            border:1px solid rgba(23,107,82,.12);box-shadow:0 16px 40px rgba(22,74,58,.08);
          }
          .twt-methodology-innovative .twt-process-step {
            border:1px solid rgba(18,52,59,.10);box-shadow:0 8px 22px rgba(18,52,59,.045);
            transition:transform .2s ease,box-shadow .2s ease;
          }
          .twt-methodology-innovative .twt-process-step:hover { transform:translateY(-4px);box-shadow:0 15px 30px rgba(18,52,59,.11); }
          .twt-methodology-innovative .twt-process-step:nth-child(1) { background:#ffffff;border-top:4px solid #168575; }
          .twt-methodology-innovative .twt-process-step:nth-child(2) { background:#f2f8ff;border-top:4px solid #3d83b7; }
          .twt-methodology-innovative .twt-process-step:nth-child(3) { background:#f7f9e9;border-top:4px solid #a4b94b; }
          .twt-methodology-innovative .twt-process-step:nth-child(4) { background:#fff7eb;border-top:4px solid #d79b42; }
          .twt-methodology-innovative .twt-process-step:nth-child(1) b { background:#168575; }
          .twt-methodology-innovative .twt-process-step:nth-child(2) b { background:#3d83b7; }
          .twt-methodology-innovative .twt-process-step:nth-child(3) b { background:#879d2e; }
          .twt-methodology-innovative .twt-process-step:nth-child(4) b { background:#bd812a; }
          .twt-methodology-innovative .twt-cream-section { background:#f7faf8; }
          .twt-methodology-innovative .twt-cream-section:nth-of-type(even) { background:#f0f6f8; }
          .twt-methodology-innovative .twt-method-card {
            border-color:rgba(18,52,59,.12);box-shadow:0 10px 28px rgba(18,52,59,.055);
          }
          .twt-methodology-innovative .twt-method-card.wide { border-left:4px solid #168575; }
          .twt-methodology-innovative .twt-method-card:nth-child(2n) { border-top:3px solid #3d83b7; }
          .twt-methodology-innovative .twt-card-number { background:#dff1e9;color:#116b59; }
          .twt-methodology-innovative .twt-flow-rule div:first-child { background:#eaf6f1;border-color:#cce7dc; }
          .twt-methodology-innovative .twt-flow-rule div:first-child strong { color:#087c63; }
          .twt-methodology-innovative .twt-flow-rule div:last-child { background:#eaf3fb;border-color:#d1e4f3; }
          .twt-methodology-innovative .twt-flow-rule div:last-child strong { color:#236d9b; }
          .twt-methodology-innovative .twt-caveat { background:#fff8e9;border-color:#f0dfb6;border-left-color:#d79b42; }
          .twt-methodology-innovative .twt-caveat .twt-card-number { background:#f8e8c8;color:#805b19; }
          .twt-methodology-innovative .twt-publications { background:linear-gradient(135deg,#e2f0e5,#e4f1f4); }
          .twt-methodology-innovative .twt-publications .pub-item { border-color:rgba(18,52,59,.14); }
          .twt-methodology-innovative .twt-publications .pub-item:hover { background:rgba(255,255,255,.82);border-color:#8fc8b8; }
          .twt-methodology-innovative .twt-hero-actions button { box-shadow:0 8px 22px rgba(217,237,154,.16); }
          .twt-methodology-innovative .twt-hero-actions button:hover { background:#e8f7b8;transform:translateY(-2px); }
          .twt-methodology-innovative .twt-method-nav .twt-method-primary:hover { background:#e8f7b8; }
          @media(prefers-reduced-motion:reduce) {
            .twt-methodology-innovative *, .twt-methodology-innovative *:before, .twt-methodology-innovative *:after { transition:none !important;scroll-behavior:auto !important; }
          }

        `}</style>

        {/* Innovative platform-first hero, using the existing IWMI assets and palette */}
        <section className="twt-platform-hero">
          <div className="twt-method-topbar">
            <div className="twt-method-logo">
              <img src={IWMI_Logo} alt="IWMI logo" />
              <span />
              <img src={CGIAR_transparent} alt="CGIAR logo" />
            </div>
            <nav className="twt-method-nav" aria-label="Methodology navigation">
              <button onClick={() => setShowMethodology(false)}>← Home</button>
              <button className="twt-method-primary" onClick={openTracker}>Explore Tracker ↗</button>
            </nav>
          </div>

          <div className="twt-hero-grid">
            <div className="twt-hero-copy">
              <p className="twt-kicker">DIWASA · SIWA+ · IWMI</p>
              <h1>Follow the journey of water <em>across borders.</em></h1>
              <p>
                The Transboundary Water Tracker (TWT), developed through DIWASA,
                is an interactive tool for exploring water movement across national
                and river-basin boundaries. It brings water-accounting information
                into one interface to help answer two essential questions: where
                does water originate, and where does it go?
              </p>
              <p>
                Explore inflows, outflows, source and destination contributions, and
                cross-border dependencies through monthly and annual views—turning
                complex river-network data into evidence that is easier to interpret.
              </p>
              <div className="twt-hero-actions">
                <button onClick={openTracker}>Explore tracker <span aria-hidden="true">→</span></button>
                <button className="twt-secondary" onClick={() => document.getElementById("twt-data-production")?.scrollIntoView({ behavior: "smooth" })}>View methodology ↓</button>
              </div>
            </div>
            <div className="twt-visual-card">
              <img src={donateWidget} alt="Transboundary Water Tracker water-flow visualisation" />
              <div className="twt-visual-caption">
                <strong>From water accounting to flow intelligence</strong>
                <span>Source → destination</span>
              </div>
            </div>
          </div>
        </section>

        <div className="twt-metric-strip" aria-label="Dataset summary">
          <div className="twt-metric"><div><b>64,000+</b><span>river segments across Africa</span></div></div>
          <div className="twt-metric"><div><b>2001–2021</b><span>AfriDischarge estimation period</span></div></div>
          <div className="twt-metric"><div><b>Multi-scale</b><span>continental to sub-national accounting</span></div></div>
        </div>

        {/* Green background deliberately retained for data production and validation */}
        <section id="twt-data-production" className="twt-section twt-data-section">
          <div className="twt-section-inner">
            <div className="twt-section-heading">
              <p className="twt-kicker">Data production and validation</p>
              <h2>From satellite observations to routed river discharge.</h2>
              <p>AfriDischarge v1 provides the hydrological foundation used to identify and analyse transboundary river flows.</p>
            </div>
            <div className="twt-data-layout">
              <article className="twt-data-copy">
                <h3>AfriDischarge v1</h3>
                <p>
                  AfriDischarge v1, also known as VegDischarge v1, provides routed
                  river discharge estimates for more than 64,000 river segments
                  across Africa from 2001 to 2021 using an integrated VegET and
                  mizuRoute modelling workflow.
                </p>
                <p>
                  VegET simulates key water-balance processes, while mizuRoute routes
                  runoff through the river network to estimate discharge. These are
                  modelled estimates—not direct measurements at every river segment.
                </p>
              </article>
              <div className="twt-data-image">
                <img src={MethodologyImg} alt="Integrated VegET hydrology and mizuRoute river-routing workflow" />
              </div>
            </div>
            <div className="twt-process" aria-label="Data production workflow">
              <div className="twt-process-step"><b>01</b><h4>Earth observation inputs</h4><p>Precipitation, vegetation, soil and other environmental datasets.</p></div>
              <div className="twt-process-step"><b>02</b><h4>VegET simulation</h4><p>Estimates evapotranspiration, soil moisture, runoff and deep drainage.</p></div>
              <div className="twt-process-step"><b>03</b><h4>mizuRoute routing</h4><p>Routes generated runoff through vector-based river networks.</p></div>
              <div className="twt-process-step"><b>04</b><h4>Validation</h4><p>Compares simulated discharge with available gauging-station observations.</p></div>
            </div>
          </div>
        </section>

        <section className="twt-section twt-cream-section">
          <div className="twt-section-inner">
            <div className="twt-section-heading">
              <p className="twt-kicker">01 · Water accounting framework</p>
              <h2>One connected picture of water stocks and flows.</h2>
              <p>DIWASA produces water accounts at multiple spatial scales so water movement can be understood within places and across borders.</p>
            </div>
            <div className="twt-method-cards">
              <article className="twt-method-card wide">
                <div className="twt-card-number">01</div>
                <div className="twt-card-body">
                  <h3>DIWASA water accounting framework</h3>
                  <p>
                    The DIWASA project has generated water accounts at continental,
                    transboundary river-basin, national, and sub-national levels.
                    Accounting within and across geographical boundaries enables
                    tracking of inflows and outflows while considering the
                    distribution and availability of water resources. Quantifying
                    water stocks and flows provides a system-wide picture to support
                    improved water-resource management.
                  </p>
                  <p>
                    At the national scale, accounting addresses internal water
                    resources generated within the country, including precipitation
                    falling within national boundaries, groundwater contributions
                    to surface flow, and surface runoff draining into rivers and
                    streams. At the transboundary basin scale, accounting tracks
                    water entering from neighbouring countries and water leaving
                    towards other countries or terminal sinks such as oceans, inland
                    lakes, and wetlands.
                  </p>
                  <p>
                    These cross-border exchanges are important for understanding
                    regional water availability and supporting cooperation,
                    coordinated management, and data sharing among countries that
                    share river basins.
                  </p>
                </div>
              </article>
            </div>
          </div>
        </section>

        <section className="twt-section twt-cream-section" style={{ paddingTop: 12 }}>
          <div className="twt-section-inner">
            <div className="twt-section-heading">
              <p className="twt-kicker">02 · Transboundary flow classification</p>
              <h2>Classifying where rivers enter—and where they leave.</h2>
              <p>IODISE translates the geometry of a river network and an administrative boundary into inflow and outflow records.</p>
            </div>
            <div className="twt-method-cards">
              <article className="twt-method-card wide">
                <div className="twt-card-number">02</div>
                <div className="twt-card-body">
                  <h3>Inflow/Outflow Discharge Extractor (IODISE)</h3>
                  <p>
                    Administrative boundaries often span several catchments, so a
                    country or region can have multiple inflows and outflows. The
                    IODISE module of the Scale Invariant Water Accounting Plus
                    (SIWA+) framework overlays the selected boundary on the river
                    network. A segment is classified as an inflow when it starts
                    outside and ends inside the boundary, and as an outflow when it
                    starts inside and ends outside. Segments entirely inside or
                    outside the boundary are excluded.
                  </p>
                  <div className="twt-flow-rule">
                    <div><strong>INFlOW · Outside → Inside</strong><span>The river segment crosses into the selected administrative area.</span></div>
                    <div><strong>OUTFLOW · Inside → Outside</strong><span>The river segment crosses out of the selected administrative area.</span></div>
                  </div>
                  <p>
                    Where a river forms the boundary, repeated crossings can create
                    spurious entry and exit points. IODISE addresses this by tracking
                    where the river finally enters or leaves and classifying it as a
                    shared inflow or shared outflow. Mean discharge for each country
                    is used to distinguish major from minor rivers.
                  </p>
                </div>
              </article>
            </div>
          </div>
        </section>

        <section className="twt-section twt-cream-section" style={{ paddingTop: 12 }}>
          <div className="twt-section-inner">
            <div className="twt-section-heading">
              <p className="twt-kicker">03 · Visualisation, validation and limitations</p>
              <h2>Make complex water transfers visible—with their uncertainties.</h2>
              <p>The tracker visualises modelled source-to-destination flows and presents them as an exploratory aid, not as a substitute for gauged observations.</p>
            </div>
            <div className="twt-method-cards">
              <article className="twt-method-card wide">
                <div className="twt-card-number">03</div>
                <div className="twt-card-body">
                  <h3>Transboundary flow visualisation with Sankey diagrams</h3>
                  <p>
                    The Python-based Transboundary Water Tracker (TWT) Tool reads
                    flow information from river-network attributes, organises it
                    into source–destination pairs, and draws Sankey links whose
                    widths are proportional to the volume transferred. Monthly and
                    annual views allow users to examine flow patterns, compare
                    inflows with outflows, and explore contributions from different
                    countries and destinations.
                  </p>
                </div>
              </article>
              <article className="twt-method-card">
                <div className="twt-card-number">A</div>
                <div className="twt-card-body">
                  <h3>Validation against observations</h3>
                  <p>
                    Inflows and outflows are model estimates rather than gauged
                    flows. Where observations are available, simulated discharge
                    has been validated against observed river flows at gauging
                    stations across Africa (Akpoti et al., 2024).
                  </p>
                </div>
              </article>
              <article className="twt-method-card twt-caveat">
                <div className="twt-card-number">!</div>
                <div className="twt-card-body">
                  <h3>Uncertainty and limitations</h3>
                  <p>
                    Long, publicly available gauging records are sparse along
                    national borders, so validation may not fully represent
                    conditions at the national scale. Errors in satellite-based
                    inputs can propagate into the simulated flow estimates.
                  </p>
                  <p>
                    The model does not explicitly account for reservoir operations,
                    water abstractions, or water losses as rivers pass through
                    lowland wetlands. Simulated inflows and outflows may therefore
                    overestimate or underestimate actual river flows.
                  </p>
                </div>
              </article>
            </div>
          </div>
        </section>

        <section className="methodology-publications green-section section-padding twt-publications">
          <div className="section-head reveal">
            <p className="eyebrow dark">Scientific references</p>
            <h2>Research underpinning the data and methodology.</h2>
          </div>
          <div className="publication-list reveal delay">
            <a href="https://doi.org/10.1038/s41597-024-04034-0" target="_blank" rel="noreferrer" className="pub-item">
              <span className="pub-number">01</span><div className="pub-content"><h4>Advancing water security in Africa with new high-resolution discharge data</h4><p>Akpoti et al. (2024)</p></div><span className="pub-link">↗</span>
            </a>
            <a href="https://doi.org/10.1080/02626667.2024.2402938" target="_blank" rel="noreferrer" className="pub-item">
              <span className="pub-number">02</span><div className="pub-content"><h4>State of continental discharge estimation and modelling</h4><p>Akpoti et al. (2024)</p></div><span className="pub-link">↗</span>
            </a>
            <a href="https://doi.org/10.5066/P14H6TFY" target="_blank" rel="noreferrer" className="pub-item">
              <span className="pub-number">03</span><div className="pub-content"><h4>Hydrologic gridded runoff and routed discharge data for Africa (2000–2021)</h4><p>USGS Data Release</p></div><span className="pub-link">↗</span>
            </a>
            <a href="https://www.iwmi.org/blogs/iwmi-research-offers-a-path-to-better-river-discharge-estimation-in-africa/" target="_blank" rel="noreferrer" className="pub-item">
              <span className="pub-number">04</span><div className="pub-content"><h4>A path to better river discharge estimation in Africa</h4><p>IWMI Blog</p></div><span className="pub-link">↗</span>
            </a>
          </div>
          <p className="twt-end-note">Interpretation note: the tracker visualises simulated discharge-based inflows and outflows. Results should be interpreted alongside available observations and the limitations described above.</p>
        </section>
      </main>
    );
  }


  return (
    <main className="hr-page">
      <section
        id="home"
        className="hero"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-overlay" />

        <div className="hero-logos reveal">
          <img className="iwmi-logo" src={IWMI_Logo} alt="IWMI Logo" />
          <span />
          <img className="cgiar-logo" src={CGIAR_transparent} alt="CGIAR Logo" />
        </div>

        <nav className="top-nav">
          <span onClick={() => scrollToSection("home")}>Home</span>
          <span onClick={openMethodology}> Methodology</span>
          <span onClick={openTracker}>Explore Tracker</span>
          <span className="events-nav-link" onClick={() => { setShowEventAnnouncement(false); setShowEventsPage(true); }}>IWMI Events <span className="events-nav-dot" /></span>
        </nav>

        <div className="hero-content reveal delay">
          <p className="eyebrow">
            IWMI • Digital Innovations for Water Secure Africa
          </p>

          <h1>
            Transboundary
            <br />
            Water Tracker
          </h1>

          <div className="title-line" />

          <h3>Shared water transfer intelligence for trusted decisions.</h3>

          <p>
            A SIWA+-powered decision-support platform that unifies fragmented
            basin data, reveals cross-border dependencies, and strengthens
            evidence-based cooperation across nations.
          </p>

          <div className="hero-actions">
            <button onClick={openTracker}>
              Explore Tracker <span aria-hidden="true">→</span>
            </button>
          </div>
     

          <div className="hero-metrics">
            <div>
              <span className="metric-icon">◖</span>
              <strong>60%</strong>
              <small>of global freshwater crosses borders</small>
            </div>
            <div>
              <span className="metric-icon">●</span>
              <strong>260+</strong>
              <small>shared basins with fragmented data</small>
            </div>
            <div>
              <span className="metric-icon">◎</span>
              <strong>SIWA+</strong>
              <small>unified water accounting approach</small>
            </div>
          </div>
        </div>

      {/* Small animated announcement on dashboard load; stays visible until dismissed. */}
      {showEventAnnouncement && featuredEvent && (
        <aside className="iwmi-event-toast iwmi-hero-event-toast" role="dialog" aria-label="IWMI event announcement">
          <span className="iwmi-toast-kicker"><span /> {currentEvents.length ? "HAPPENING NOW" : "UPCOMING IWMI EVENT"}</span>
          <h3>{featuredEvent.title}</h3>
          <p className="iwmi-toast-title">{formatEventDate(featuredEvent)}</p>
          <p className="iwmi-toast-meta">{featuredEvent.location}</p>
          <button className="iwmi-toast-action" onClick={() => { setShowEventAnnouncement(false); setShowEventsPage(true); }}>View event details <span>↗</span></button>
        </aside>
      )}

        <button
          className="scroll-cue"
          onClick={() => scrollToSection("impact")}
          aria-label="Scroll to content"
        >
          ↓
        </button>
      </section>

      {/* ⛔ NOTHING ELSE CHANGED BELOW */}
      {/* Your remaining sections stay EXACTLY same */}

      <section id="impact" className="impact green-section section-padding">
        <div className="section-head reveal">
          <p className="eyebrow dark">The challenge</p>
          <h2>When shared water flows remain invisible, decisions become fragile.</h2>
        </div>

        <div className="impact-layout">
          <p className="impact-left reveal">
            Nearly 60% of global freshwater moves through transboundary basins,
            yet the data needed to manage these shared resources is often
            incomplete, inconsistent, or inaccessible.
          </p>

          <div className="quote reveal">
            <p>
              More than 260 shared basins face fragmented monitoring practices,
              limiting countries’ ability to plan at basin scale and respond to
              growing climate and population pressures.
            </p>
          </div>

          <div className="quote reveal delay">
            <p>
              When reliable tracking is missing, water allocation becomes less
              transparent, increasing the risk of over-extraction, food
              insecurity, and tension between upstream and downstream users.
            </p>
          </div>
        </div>
      </section>

      <section id="action" className="action cream-section section-padding">
        <div className="section-head reveal">
          <p className="eyebrow dark">The solution</p>
          <h2>A refined intelligence layer for shared river basins</h2>
        </div>

        <div className="cards-grid">
          <article className="action-card reveal">
            <img src={actionOne} alt="Satellite and water accounting data" />
            <div>
              <h3>One trusted data framework</h3>
              <p>
                SIWA+ combines earth observation data and hydrologic modeling to
                create a consistent, basin-wide view of water availability,
                movement, and use beyond national boundaries.
              </p>
              <button onClick={openMethodology}>Explore SIWA+</button>
            </div>
          </article>

          <article className="action-card reveal delay">
            <img src={actionTwo} alt="Water governance and basin analytics" />
            <div>
              <h3>Evidence for timely action</h3>
              <p>
                Near real-time monitoring and historical baselines help decision
                makers identify trends, anticipate scarcity, and move from
                reactive management to informed planning.
              </p>
              <button onClick={openTracker}>Explore Tracker</button>
            </div>
          </article>
        </div>
      </section>

      <section className="involved green-section section-padding">
        <div className="section-head reveal">
          <p className="eyebrow dark">Why it matters</p>
          <h2>From fragmented observations to shared confidence.</h2>
        </div>

        <div className="involved-grid">
          <div className="involved-card reveal">
            <h3>Standardize</h3>
            <p>
              Align water accounting across countries with a common, transparent
              evidence base for transboundary basin planning.
            </p>
            <button onClick={() => scrollToSection("action")}>View solution</button>
          </div>

          <div className="involved-card reveal delay">
            <h3>Collaborate</h3>
            <p>
              Support constructive dialogue by showing how water flows,
              dependencies, and risks connect member states.
            </p>
            <button onClick={() => scrollToSection("impact")}>See challenge</button>
          </div>

          <div className="involved-card reveal delay-2">
            <h3>Decide</h3>
            <p>
              Enable stronger decisions for allocation, adaptation, food
              security, and long-term water resilience.
            </p>
            <button onClick={openTracker}>Explore Tracker</button>
          </div>
        </div>
      </section>

      <section id="donate" className="donate blue-section section-padding">
        <div className="donate-content reveal">
          <div>
            <p className="eyebrow light">Water intelligence platform</p>
            <h2>See every basin as one connected system</h2>
            <p>
              The Transboundary Water Tracker transforms complex hydrologic data
              into clear visual evidence, helping governments, researchers, and
              basin organizations understand supply, demand, dependency, and risk
              across borders.
            </p>
            <button onClick={openTracker}>Explore Tracker</button>
          </div>

          <img src={donateWidget} alt="Transboundary Water Tracker visual" />
        </div>
      </section>

      <section
        className="field-band"
        style={{ backgroundImage: `url(${fieldBg})` }}
      >
        <div className="field-text reveal">
          <h2>
            Clear evidence for fairer, smarter, and more resilient water
            governance.
          </h2>
        </div>
      </section>

      <section className="mission cream-section section-padding">
        <div className="mission-card reveal">
          <h3>Volta River Basin case study</h3>
          <p>
            In the Volta Basin, SIWA+ translates complex cross-border flow data
            into intuitive visual evidence, showing how six riparian countries
            are connected through shared water movement.
          </p>
        </div>

        <div className="mission-card reveal delay">
          <h3>Insights that reveal interdependence</h3>
          <p>
            The tracker highlights Togo’s role as a conduit for flows from Benin
            to Ghana and identifies Burkina Faso as a major contributor to
            Ghana’s basin inflows, supporting more informed regional dialogue.
          </p>
        </div>
      </section>

      <section id="partners" className="partners section-padding">
  <div className="partners-head reveal">
    <p className="eyebrow dark">Our partners</p>
    <h2>Working together for smarter transboundary water governance.</h2>
    <p>
      The Transboundary Water Tracker is designed to support collaboration
      between research institutions, basin organizations, governments, and
      development partners.
    </p>
  </div>

  <div className="partner-logo-grid reveal delay">
    <div className="partner-logo-card">
      <img src={partnerLogo1} alt="Partner logo 1" />
    </div>

    <div className="partner-logo-card">
      <img src={partnerLogo2} alt="Partner logo 2" />
    </div>

    <div className="partner-logo-card">
      <img src={partnerLogo3} alt="Partner logo 3" />
    </div>

    <div className="partner-logo-card">
      <img src={partnerLogo4} alt="Partner logo 4" />
    </div>
  </div>
</section>


    </main>
  );
}

